import { getMemberFriends } from './get-member-friends';
export const getMemberFriendById = (friendId) => {
    var _a;
    return (_a = getMemberFriends()) === null || _a === void 0 ? void 0 : _a.find(friend => friend.id === friendId);
};
